import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DropDownTreeViewItemViewModelType from '@/ViewModels/Controls/DropDownTreeViewItemViewModel';
import LabelType from '@/Controls/Label';

export default class DropDownTreeViewItem extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;

    public constructor(private viewModel: DropDownTreeViewItemViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl!= null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<li>');

        this.applyBindings(this.jQueryControl, {
            checkable: this.viewModel.isCheckable
        });

        return this.jQueryControl;
    }
}

ComponentManager.setControl('DropDownTreeViewItem', DropDownTreeViewItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');